import axios from "axios";
import { firebaseAuth } from "../firebase/firebaseClient";

let configured = false;

function stripTrailingSlash(s) {
  return String(s || "").replace(/\/$/, "");
}

function splitAbsoluteUrl(url) {
  try {
    const u = new URL(url);
    return {
      origin: `${u.protocol}//${u.host}`,
      pathAndQuery: `${u.pathname}${u.search || ""}`
    };
  } catch {
    return null;
  }
}

export function configureGlobalAxios() {
  if (configured) return;
  configured = true;

  const functionsBaseURL = stripTrailingSlash(process.env.REACT_APP_FUNCTIONS_BASE_URL || "");
  if (!functionsBaseURL) {
    throw new Error("Missing REACT_APP_FUNCTIONS_BASE_URL in frontend/.env.");
  }

  axios.interceptors.request.use(async (config) => {
    const rawUrl = typeof config.url === "string" ? config.url : "";
    const usingFunctionsBase = true;

    if (/^https?:\/\//i.test(rawUrl)) {
      const split = splitAbsoluteUrl(rawUrl);
      if (split) {
        config.baseURL = functionsBaseURL;
        config.url = split.pathAndQuery;
      }
    } else {
      config.baseURL = functionsBaseURL;
    }

    let token =
      String(localStorage.getItem("authToken") || "").trim() ||
      String(localStorage.getItem("mockAuthToken") || "").trim();

    if (!token) {
      try {
        const raw = localStorage.getItem("userInfo");
        if (raw) {
          const parsed = JSON.parse(raw);
          token = String(parsed?.access || parsed?.authToken || parsed?.idToken || "").trim();
        }
      } catch {
        // ignore
      }
    }

    if (!token && usingFunctionsBase) {
      const user = firebaseAuth.currentUser;
      if (user) token = await user.getIdToken();
    }

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (usingFunctionsBase && typeof config.url === "string" && config.url.startsWith("/api/")) {
      config.url = config.url.slice(4);
    }

    return config;
  });
}

